//Gli import funzionano come nel file app.js, l'unica differenza è che bisogna tenere conto del diverso path di partenza, poiché i percorsi sono relativi al file corrente.
//In una versione futura del progetto base (quindi dei file di configurazione) potrebbero essere configurate delle directory base per cui, per esempio, sarà sufficiente scrivere "managers/userManager" per caricare il relativo modulo.
import { Shark } from "shark-mvc";

import  { Driver } from "Models/Driver";
import { driverManager } from "Managers/driverManager";

//Importiamo tutte le view che potrebbero essere necessarie in questo file.
// import { homeView } from "./homeView.js";

//Se questo modulo prevede una parte visuale (quindi le View e i Components) bisogna importare il relativo file html in una variabile da assegnare, successivamente, alla proprietà templateContent di questa View/Component.
import templateContent from "Templates/views/login.html";
import { homeView } from "./homeView";
import { vehicleManager } from "../managers/vehicleManager";

//Creiamo la nuova View utilizzando il metodo createJaw di Shark. In futuro potrebbero esserci metodi differenziati per creare View, Managers e Components.
var loginView = Shark.createJaw("loginView");

//Assegnamo a questa view il contenuto del suo template. (caricato qualche riga più su)
loginView.templateContent = templateContent;
loginView.route = "login";

//Cominciamo ad aggiungere i metodi che saranno esposti per questo oggetto. Shark gestisce in automatico alcuni callback riferiti al ciclo di render, e gestisce in automatico anche l'assegnazione dei listeners sull'interfaccia e sugli altri elementi dell'applicazione (i Managers, di fatto) basandosi su una semplice logica di name templating.

//I callback che intercettano il ciclo di render sono i seguenti (in ordine di esecuzione):
/*
- onRegister
Viene chiamato quando l'elemento è registrato su Shark, quindi inidipendentemente dal fatto che l'elemento (View, Component, Controller) venga effettivamente poi richiamato nel flusso della programmazione.
Si differenzia da "init" in quanto quest'ultimo viene chiamato solo se l'elemento viene utilizzato (quindi messo a schermo), mentre onRegister viene chiamato prima ancora che l'applicazione sia inizializzata.

- init
Viene chiamato la prima volta che una View viene aperta o che un Component viene chiamato da una View (durante l'inizializzazione di questa). Dopo la prima volta che la View viene aperta questo metodo non viene più chiamato.
Qui andrebbe messa l'inizializzazione di eventuali variabili che siano indispensabili al funzionamento della View ed impostati eventuali valori di default.
In questo metodo bisogna chiamare il metodo this.addComponents() che permette di aggiungere componenti alla View corrente.

- beforeLoad
Viene chiamato tutte le volte che la View viene richiamata dal comando Shark.openPage(). In futuro sarà affiancato e poi sostituito da "beforeOpen".
Questo metodo viene chiamato anche se la View è già aperta e viene chiamato di nuovo Shark.openPage() con la stessa View.

- beforeRender
Viene chiamato subito prima che venga effettuato il render della View (o del component) e può essere utile per effettuare validazione di dati, sorting, impostazione di valori da mostrare a schermo, ecc... Viene chiamo TUTTE le volte che lo schermo viene renderizzato, inidipendentemente dal fatto che il render sia forzato con Shark.render() o che sia richiesto dal normale flusso dell'app.
Questo metodo viene chiamato solo per la View attiva e per i Components che questa incorpora.

- afterRender
Viene chiamato subito dopo il render della View. Quando è chiamato l'html della pagina è completo e il ciclo di render è concluso. Sebbene sarebbe meglio evitare, ogni tanto è indispensabile inserire in questo callback della logica di alterazione o interazione con l'html. Ad esempio alcuni plugin di jQuery o Bootstap richiedono di agire sull'HTML già renderizzato e quindi devono essere gestiti in questo in questo punto.

- beforeUnload
Questo metodo viene chiamato subito prima che questa View venga "scaricata" per aprirne un'altra. Utile per ripulire eventuali dati che non devono rimanere in memoria, resettare variabili o tenere traccia del passaggio. In futuro verrà affiancato e poi sostitutito da "beforeClose".
In pratica, viene chiamato subito prima del "beforeLoad" (ed eventuale "init") della prossima View.

Sui Components sono presenti anche i seguenti callback:
jawInit
Viene chiamato quando la view che contiene questo Component viene inizializzata.

Esistono anche alcuni callback generici da utilizzare assegnando in modo statico una funzione a specifiche proprietà di Shark:
- Shark.beforeRenderEachPage
Viene chiamato prima del render di ogni pagina. Viene chiamato prima del beforeRender della singola View.

- Shark.afterRenderEachPage
Viene chiamato dopo il render di ogni pagina. Viene chiamato successivamente all'afterRender della singola View.
*/

// loginView.addMethod("afterRender", function () {
// 	//In questa funzione viene usato il metodo Shark.get() per accedere ad elementi del DOM. Per il momento è un semplice wrapper per il $("") di Query, ma permette di non usare Query.
// 	//Non è il modo più elegante di farlo, ma per ora è un buon compromesso.
// 	//Queste operazioni sono fatte nell'afterRender perché agendo sull'HTML deve aspettare che il render sia completato.
	
// 	//document.body.classList.add("text-center");

// 	if (Shark.get("currUser").eMail !== "") {
// 		Shark.get("#passwordField").focus();
// 	}
// 	else {
// 		Shark.get("#usernameField").focus();
// 	}
// });

loginView.addMethod("beforeLoad", function () {
	//Al caricamento della pagina verifico se è stato conservato un utente precedentemente loggato e mi comporto di conseguenza.
	//Vengono usati il metodo Shark.getInstance() per creare un'istanza di un Model ed il metodo Shark.set() per conservare le istanze nello store dell'applicazione.
	if (localStorage.getItem("currDriver")) {
		const loggedDriver = JSON.parse(localStorage.getItem("currDriver"));

		if (loggedDriver.preserveLogin) {
			Shark.set("currDriver", Shark.getInstance("Driver", loggedDriver));
		}
	}
	else {
		const lastUserEMail = localStorage.getItem("lastUserEMail") || "";

		Shark.set("currDriver", Shark.getInstance("Driver", {eMail: lastUserEMail}));
	}
});

// /*
// Shark gestisce in automatico l'assegnazione di listeners agli elementi presenti nell'HTML usando una semplice regola di name templating.
// La regola è: selettoreCss_nomeeventoHandler.
// Dove:
// - selettoreCss è un qualsiasi selettore CSS di base, quindi un ID, una classe, o un elemento. In futuro questa funzionalità verrà estesa per supportare qualsiasi tipo di selettore.
// - nomeevento è il nome dell'evento che deve essere gestito scritto esattamente come viene emesso. Vengono gestiti in egual modo sia gli eventi di "sistema" (click, mousemove, keyup, ecc..) che eventuali eventi custom creati dallo sviluppatore.
// - Handler è una parte fissa del nome della funzione che indica a Shark che questo è un handler per la coppia elemento + evento precedentemente idenfiticato.

// A questa funzione verranno passati due argomenti:
// - event è l'evento originale emesso dall'elemento che stiamo ascoltando.
// - data è un oggetto che contiene tutti i data-attribures dell'elemento HTML che ha generato l'evento. Per completezza bisogna notare che questo parametro è di default solo se l'evento che stiamo gestendo è un evento legato ad un elemento HTML; se invece si tratta di un evento legato ad un Controller l'unico parametro di default è l'event, il resto è a discrezione di chi scrive il controller. (vedi oltre)

// Il valore di this in questi metodi è sempre la View stessa.
// */
loginView.addMethod("logInBtn_clickHandler", function () {
	//Poiché il form di login è legato automaticamente (con gli attributi data-sh-xxxx) al model "currUser" nello store dell'applicazione, alla pressione del tasto "logInBtn" è sufficiente procedere ad invocare il metodo "login" sul Controller "userManager" passandogli semplicemente l'utente da utilizzare.
	//Qui sarebbe sensato inserire la logica di validazione dei dati: controllare che sia l'indirizzo eMail che la password siano stati compilati, fare le verifiche formali, ecc. Un'alternativa potrebbe essere quella di inserire un metodo per la validazione nel Model.
	console.log(Shark.get("currDriver"));
	driverManager.logIn(Shark.get("currDriver"));
});

// loginView.addMethod("passwordField_keyupHandler", function (event) {
// 	//Alla pressione di un tasto sulla tastiera controlliamo se è stato premuto il tasto "return" e, nel caso, chiamiamo comunque il metodo di login. (vedi funzione precedente)
// 	if (event.which === 13) {
// 		userManager.logIn(Shark.get("currUser"));
// 	}
// });

// /*
// Shark gestisce in automatico l'assegnazione di listeners ai Controllers registrati usando una semplice regola di name templating.
// La regola è: nomeController_nomeeventoHandler.
// Dove:
// - nomeController è il nome di uno dei Controller registrati in Shark con il metodo Shark.registerController().
// - nomeevento è il nome dell'evento che deve essere gestito scritto esattamente come viene emesso. Al momento Shark non prevede eventi di defautl per i Controllers, quindi questo parametro deve corrispondere ad un evento custom creato dallo sviluppatore.
// - Handler è una parte fissa del nome della funzione che indica a Shark che questo è un handler per la coppia Controller + evento precedentemente idenfiticato.

// A questa funzione verrà passato un solo argomento:
// - event è l'evento originale emesso dall'elemento che stiamo ascoltando.

// Lo sviluppatore ha facoltà di associare all'evento emesso dal controller dei dati che verranno passati a questo metodo come argomenti successivi ad event.

// Il valore di this in questi metodi è sempre la View stessa.
// */
loginView.addMethod("driverManager_loggedInHandler", function () {
	const driver = Shark.get("currDriver");
	
	if (driver.preserveLogin) {
		localStorage.setItem("currDriver", JSON.stringify(driver));
	}
	else {
		localStorage.removeItem("currDriver");
		localStorage.removeItem("sessionToken");
	}

	vehicleManager.getList();
});

loginView.addMethod("driverManager_logInErrorHandler", function (event, data) {
	if (data === "Wrong Credential") {
		alert("Attenzione, i dati inseriti non corrispondono ad un utente");
	}
	else {
		alert("Mi spiace, si è verificato un errore");
	}
});

loginView.addMethod("vehicleManager_listChangedHandler", function () {
	Shark.openPage(homeView);
});

//Qeusto comando serve a registrare questa View all'interno dell'ecosistema di Shark, serve a renderla disponibile agli altri elementi dell'app e a gestire l'assegnazione dei comportamenti predefiniti da Shark.
Shark.registerView(loginView);

//Questo comando è l'export di default dei moduli di ES6, serve a trasformare questo file in un Modulo, e renderlo importabile dagli altri moduli dell'app.
export { loginView };
